export const dataLibE = [{
  word: 'èvèk',
  partOfSpeech: 'CONJ',
  definition: ['and'],
  egSentenceKw: 'Kouman Pyè èvèk Mawi yé?',
  egSentenceEn: 'How are Peter and Mary?',
  synonym: ['épi'],
  antonym: ['san'],

  etymology: '[< Fr. avec]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'èvèk',
  partOfSpeech: 'PREP',
  definition: ['with'],
  egSentenceKw: 'Si ou pa vlé alé èvèk mwen, mwen kay alé pa kò mwen.',
  egSentenceEn: 'If you  don\'t want to go with me, I\'ll go alone.',
  synonym: ['épi'],
  antonym: [null],
  etymology: '[< Fr. avec]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'èk',
  partOfSpeech: null,
  definition: [],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['èvèk'],
}, {
  word: 'épi',
  partOfSpeech: 'CONJ',
  definition: ['and'],
  egSentenceKw: 'Mwen genyen pen épi yonn dé ti bagay.',
  egSentenceEn: 'I bought bread and a few small things.',
  synonym: ['èvèk'],
  antonym: ['san'],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['é', 'èp'],
}, {
  word: 'épi',
  partOfSpeech: 'PREP',
  definition: ['with'],
  egSentenceKw: 'Mennen mwen épi\'w!',
  egSentenceEn: 'Take me with you!',
  synonym: ['èvèk'],
  antonym: ['san'],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['é', 'èp'],
}, {
  word: 'ensiswatil',
  partOfSpeech: 'INTERJ',
  definition: ['amen'],
  egSentenceKw: 'Mwen ka mandé tout sé bagay an non Jézi Kwi, ensiswatil.',
  egSentenceEn: 'I ask all of these things in the name of Jesus Christ, amen.',
  synonym: ['amèn'],
  antonym: [null],
  etymology: '[< Eng. amen]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'èkstré',
  partOfSpeech: 'N',
  definition: ['x-ray'],
  egSentenceKw: 'Dòktè-a ka gadé èkstré fwisi misyé-a.',
  egSentenceEn: 'The doctor is looking at the x-ray of the man\'s lungs.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. x-ray]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'èkstré',
  partOfSpeech: 'V',
  definition: ['to x-ray', 'to take an x-ray'],
  egSentenceKw: 'Tifi-a té adan an aksidan épi yo té ni pou èkstré tèt li.',
  egSentenceEn: 'The girl was in an accident and they had to x-ray her head.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. x-ray]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'èksèpté',
  partOfSpeech: 'PREP',
  definition: ['except'],
  egSentenceKw: 'Yo mennen tout bagay èksèpté sa.',
  egSentenceEn: 'They took everything except that.',
  synonym: ['anba', 'antiwan'],
  antonym: [null],
  etymology: '[< Fr. excepté]',
  dialect: '🇱🇨',
  variant: ['asèpté'],
}, {
  word: 'èksèpté',
  partOfSpeech: 'CONJ',
  definition: ['unless'],
  egSentenceKw: 'Ou pa kay sové èksèpté ou konnèt Jézi.',
  egSentenceEn: 'You won\'t be saved unless you know Jesus.',
  synonym: ['anba', 'antiwan'],
  antonym: [null],
  etymology: '[< Fr. excepté]',
  dialect: '🇱🇨',
  variant: ['asèpté'],
},
];
